import { render, staticRenderFns } from "./WorkerSex.vue?vue&type=template&id=db0b973c"
import script from "./WorkerSex.vue?vue&type=script&lang=js"
export * from "./WorkerSex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports